/**
 * PortalTabs
 *
 * Handles the creating and managing the account selection widget
 */

// the constructor for this object
function PortalBoxTabs() { }

// the object
PortalBoxTabs.prototype = {
    constructor: PortalBoxTabs,
    
    // the selector for the box tabs element
    boxTabsSelector: false,
    
    // the callback to be executed when a tab is clicked
    tabClickCallback: null,
    
    setupBoxTabs: function(selector)
    {
        this.boxTabsSelector = selector;
    
        this._registerEvents();
    },
    
    // create the on click events for the tabs
    _registerEvents: function()
    {
        var self = this;
        $(this.boxTabsSelector).each(function() {
            
            var boxTabsContainer = this;
            
            $('ul.tabs li a', boxTabsContainer).each(function() {
                $(this).on('click', function() {
                    
                    // set this tab to visible
                    $('ul.tabs li', boxTabsContainer).removeClass('current');
                    $(this).closest('li').addClass('current');
                    
                    // set the content to visible
                    var tabTarget = $(this).attr('data-target');    
                    $('.box', boxTabsContainer).removeClass('current');
                    $('#' + tabTarget, boxTabsContainer).addClass('current');
                
                    // execute the callback if applicable
                    if (typeof self.tabClickCallback == 'function') {    
                        self.tabClickCallback(tabTarget);
                    }
                });
            });
        });
    }
}
